import { render, staticRenderFns } from "./NewPerformances.vue?vue&type=template&id=2d29bcfe"
import script from "./NewPerformances.vue?vue&type=script&lang=js"
export * from "./NewPerformances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports